import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LocationPicker from './LocationPicker';

const BusinessUnitForm = ({ formData, submitted, handleChange, handleLocationChange, handleSubmit, resetForm, isLocalized, handleCheckboxChange, children }) => {

    const [t] = useTranslation("global")

    const [manualGps, setManualGps] = useState(true)

    const handleManualGpsCheckboxChange = () => {
        setManualGps(!manualGps);
    };


    function handlePickerLocationChange(location) {
        if (!manualGps) {
            console.log("New Location handled from picker")
            handleLocationChange(location)
        } else return
    }


    console.log("manualGPS: " + manualGps)
    return (
        <div className="container">
            {submitted ? (

                children
            ) : (
                <form onSubmit={handleSubmit}>


                    <div className='row'>
                        <div className='col-6'>
                            <div className='row'>
                                <div className='col'>
                                    <div className="card text-white bg-dark mb-3">
                                        <div className="card-header"><i className="fa-solid fa-circle-info"></i> {t("property.infos")}</div>
                                        <div className="card-body">

                                            <div className='row'>
                                                <div className='col-6'>
                                                    <div className="form-group">
                                                        <label htmlFor="code">Code</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="code"
                                                            value={formData.code}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className='col-8'>
                                                    <div className="form-group">
                                                        <label htmlFor="name">Name</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="name"
                                                            value={formData.name}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='row mt-2'>
                                                <div className='col'>
                                                    <div className="form-group form-check">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            id="localize"
                                                            checked={isLocalized}
                                                            onChange={handleCheckboxChange}
                                                        />
                                                        <label className="form-check-label" htmlFor="localize">
                                                            Localize
                                                        </label>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col'>
                                    {isLocalized && (
                                        <div className="card text-white bg-dark mb-3">
                                            <div className="card-header"> <i className="fa-solid fa-location-dot"></i>  {t("property.location")}</div>
                                            <div className="card-body">
                                                <div className="form-group form-check">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        id="manualGps"
                                                        checked={manualGps}
                                                        onChange={handleManualGpsCheckboxChange}
                                                    />
                                                    <label className="form-check-label" htmlFor="manualGps">
                                                        Insert manually
                                                    </label>

                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="latitude">Latitude</label>
                                                    <input
                                                        type="number"
                                                        step="any"
                                                        className="form-control"

                                                        id="latitude"
                                                        value={formData.latitude}
                                                        onChange={handleChange}
                                                        required
                                                        disabled={!manualGps}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="longitude">Longitude</label>
                                                    <input
                                                        type="number"
                                                        step="any"
                                                        className="form-control"
                                                        id="longitude"
                                                        value={formData.longitude}
                                                        onChange={handleChange}
                                                        disabled={!manualGps}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                </div>
                            </div>
                            <div className='d-grid gap-2 d-flex p-2'>
                                <button type="submit" className="btn btn-primary"><i className="fa-solid fa-floppy-disk"></i> {t("action.save")}</button>
                            </div>
                        </div>
                        <div className='col-6'>
                            {
                                isLocalized &&
                                <LocationPicker
                                    locationName={formData.name}
                                    latitude={formData.latitude}
                                    longitude={formData.longitude}
                                    onPositionChange={handlePickerLocationChange}
                                    markerMoveTracking={!manualGps}
                                />
                            }
                        </div>
                    </div>
                </form>
            )}
        </div>
    );
};

export default BusinessUnitForm;
